import { render, staticRenderFns } from "./layout-tab.vue?vue&type=template&id=e35bd40a"
import script from "./layout-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./layout-tab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./layout-tab.vue?vue&type=style&index=0&id=e35bd40a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports